import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CotizacionComponent } from './cotizacion/cotizacion.component';
import { CotizacionDetallleComponent } from './cotizacion-detallle/cotizacion-detallle.component';
import { ListadoCotizacionComponent } from './listado-cotizacion/listado-cotizacion.component';

const routes: Routes = [
  {
    path: '', children: [
      { path: 'crear_cotizacion', component: CotizacionComponent },
      { path: 'detalle_cotizacion/:idCotizacion', component: CotizacionDetallleComponent },
      { path: 'mis_cotizaciones', component: ListadoCotizacionComponent },

    ]
  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QuotationRoutingModule { }
